// extracted by mini-css-extract-plugin
module.exports = {"tab":"_23gCGgCEf-NxMlqAVmO1ln","selected":"_1n7-8jS4ymLYIQSqyDXHPn","tabText":"_22jxaUIeJ8Dxzn5wDr9Jdh"};